.search-results-empty-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 16px 32px;
    min-height: 200px;
}

.icon {
    fill: var(--icon-secondary);
    margin-bottom: 8px;
}

.title {
    font-size: 17px;
    margin-bottom: 16px;
    color: var(--grey-dk);
}

.subtitle {
    font-size: 15px;
    line-height: 19px;
    font-weight: normal;
    color: var(--grey-lt);
}
